import type { Client } from './client.js';

export interface RecordUserEventInput<
  Origin extends string = string,
  Metadata = Record<string, unknown>,
> {
  eventType: string;
  origin: Origin;
  metadata: Metadata;
}

export async function recordUserEvent<
  Origin extends string = string,
  Metadata = Record<string, unknown>,
>(
  client: Client,
  input: RecordUserEventInput<Origin, Metadata>
): Promise<void> {
  await client.request('POST', '/events', {
    body: input,
  });
}
